import {useSelector} from 'react-redux';


export const useEnvironmentContext = (): {
  isExtension: boolean;
  isClientIframe: boolean;
} => {
  // @ts-expect-error - TS2339 - Property 'env' does not exist on type 'DefaultRootState'.
  const {context} = useSelector((state) => state.env.query);
  const isExtension = context === 'chrome-extension';
  const isClientIframe = context === 'client-iframe';

  return {isExtension, isClientIframe};
};
